import { Box, Heading, Text, List, ListItem } from '@chakra-ui/react'

const Mistakes = () => (
  <Box>
    <Heading as="h4" size="md" mt={6} mb={2} color="red.600">
      Implementation Mistakes to Avoid
    </Heading>
    <List spacing={3} mb={4}>
      <ListItem><Text fontSize="sm"><b>Emotional Overrides:</b> The most common mistake is ignoring signals based on external news or personal opinions. Always follow the system.</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Inconsistent Position Sizing:</b> Varying your position size based on confidence rather than following the 75% rule leads to suboptimal results.</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Missing Trading Days:</b> The strategy requires consistent monitoring. Missing even a few signals can significantly impact performance.</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Inappropriate Timeframes:</b> This is a daily strategy. Attempting to apply these rules to hourly or weekly data will produce poor results.</Text></ListItem>
      <ListItem><Text fontSize="sm"><b>Neglecting Stop Losses:</b> Always implement the 8% stop loss. The backtest success assumes proper risk management.</Text></ListItem>
    </List>
  </Box>
)

export default Mistakes
